import { Dispatch, Store } from "redux";
import { TActionRequest } from "../../base/types/redux";
import MiddlewareRegistry from "../../base/redux/MiddlewareRegistry";
import { apiLogin } from "./services";
import { ACTION_TYPES } from "./actionTypes";
import { setListPackage} from "./actions";

export const middleware =
  ({ dispatch, getState }: Store) =>
  (next: Function) =>
  async (action: TActionRequest<any>) => {
    next(action);
    switch (action.type) {
      case ACTION_TYPES.GET_LIST_PACKAGE: {
        return await handleGetListPackage(dispatch, action, getState);
      }
    }
  };

MiddlewareRegistry.register(middleware);

const handleGetListPackage = async (
  dispatch: Dispatch,
  action: TActionRequest<any>,
  getState: () => {  }
) => {
  try {
    const response = await apiLogin(action.params!);
    if (response?.status.code === "A200") {
      dispatch(setListPackage(response));
    }
  } catch (err) {
    // dispatch(setUserInfo(response.data));
  }
};